import React, {Component} from 'react';
import './pageCss/Projects.css';
import projectJson from '../data/projects.json'
import ProCom from '../components/ProCom'
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

class Projects extends Component {

    constructor() {
        super();
        //Set default message
        this.state = {
        projects: projectJson,
        }
      }

      render(){ 
  return (
<div class="project">
<div class="project-section-1">
    {this.state.projects.map((pro)=>
    <Link to={"/Project/" + pro.id}><ProCom 
    itemClass = "ps1-item"
    pClass = "ps1-pro-des"
    hClass = "ps1-pro-tit"
    imgClass = "ps1-pro-logo"
    type = {pro.type}
    title = {pro.title}
    img = {pro.image}
    bgColor = {pro.bgColor}
    boxShadow = {pro.boxShadow}
    /></Link>
    )}
</div>
</div>
  );
}
}

export default Projects;
